import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class RegionalCheckIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#38b113' : this.getColor()

        return [
            <path d="M10.436,5.82,6.195,10.062h0a.911.911,0,0,1-1.288,0h0L2.97,8.127A.911.911,0,0,1,4.258,6.838L5.55,8.13l3.6-3.6A.911.911,0,1,1,10.436,5.82Z" transform="translate(-2.703 -4.266)" fill={color} fillRule="evenodd"/>
        ]
    }
    getViewBox = () => '0 0 8 6.064'
}
